import React, { useState, useEffect } from "react";

import { GetSingleAncillaryResponse } from "../../../../../../../common/api/catalogue-api/ancillary/GetSingleAncillaryResponse";
import { useCatalogueAncillarySearchApi } from "../../../../../../../common/api/catalogue-api/ancillary/useCatalogueAncillarySearchApi";
import { BuzzVersionsList } from "../../../../../common/buzz-version/BuzzVersionsList";
import { MediaBuzzVersion, mapAncillaryToMediaBuzzVersion } from "../../../../../common/buzz-version/MediaBuzzVersion";

interface CloudAncillaryVersionInfoProps {
    ancillaryId: string;
}

export const CloudAncillaryVersionInfo: React.FC<CloudAncillaryVersionInfoProps> = (
    props: CloudAncillaryVersionInfoProps
) => {
    const { ancillaryId } = props;

    const { getSingleAncillary } = useCatalogueAncillarySearchApi();

    const [ancillaryVersion, setAncillaryVersion] = useState<MediaBuzzVersion[]>([]);

    useEffect(() => {
        getSingleAncillary(ancillaryId).then((response: GetSingleAncillaryResponse) => {
            const version = mapAncillaryToMediaBuzzVersion(response.version);

            setAncillaryVersion([version]);
        });
    }, [ancillaryId]);

    return <BuzzVersionsList versions={ancillaryVersion} />;
};
